import React from 'react';

export default function FormHorizontalSeparator(props) {
    return <div className="tw-w-full tw-border-b tw-border-1 tw-border-grey"></div>;
}
